import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { prepareSiteSession, sessionStorageKey } from "./siteStorage";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// On an ACT site the session lives in a cookie for all of actuniverse.com, so
// the hub and every game on its own subdomain share one account (ACT HQ
// DR-0017, siteStorage.ts). Elsewhere (dev, previews) it stays in localStorage.
const siteSession = url && anonKey ? prepareSiteSession(url) : null;

/**
 * Supabase client singleton, or `null` when not configured (e.g. static hosting
 * without the Foundations env). Callers fall back to legacy guest identity so the
 * game still runs offline / pre-provisioning. Foundations F1.
 *
 * The anon key is public by design; row-level security is the real gate.
 */
export const supabase: SupabaseClient | null =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: false,
          storageKey: sessionStorageKey(url),
          ...(siteSession ? { storage: siteSession } : {}),
        },
      })
    : null;

export const isSupabaseConfigured = supabase !== null;
